import { gql } from '@apollo/client';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { client } from '..';
import { CREATE_ISSUE, GET_ALL_ISSUES, UPDATE_ISSUE,DELETE_ISSUE } from '../Queries/issue';
import { setLoader } from './loaderSlice';

export const createIssueThunk = createAsyncThunk(
  'issues/createIssue',
  async (issueData, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_ISSUE,
        variables: issueData,
        fetchPolicy: 'no-cache',
      });

      const result = data?.CreateIssue;

      if (!result) {
        return rejectWithValue('Failed to create issue.');
      }

      return result;
    } catch (error) {
      console.error('Error creating issue:', error);
      return rejectWithValue(error?.message || 'Failed to create issue.');
    }
  }
);

export const deleteIssueThunk = createAsyncThunk(
  'issues/deleteIssue',
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_ISSUE,
        variables: { id },
        fetchPolicy: 'no-cache',
      });

      const result = data?.DeleteIssue;

      if (!result) {
        return rejectWithValue('Failed to delete issue.');
      }

      return result; // returning { _id }
    } catch (error) {
      console.error('Error deleting issue:', error);
      return rejectWithValue(error?.message || 'Failed to delete issue.');
    }
  }
);


export const getAllIssuesThunk = createAsyncThunk(
  'issues/getAllIssues',
  async (_, {dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoader(true))
      const { data } = await client.query({
        query: GET_ALL_ISSUES,
        fetchPolicy: 'no-cache',
      });

      const result = data?.GetAllIssues;

      if (!result) {
        return rejectWithValue('Failed to fetch issues.');
      }

      return result;
    } catch (error) {
      console.error('Error fetching issues:', error);
      return rejectWithValue(error?.message || 'Failed to fetch issues.');
    }
    finally{
        dispatch(setLoader(false))
    }
  }
);

export const updateIssueThunk = createAsyncThunk(
  'issues/updateIssue',
  async (issueUpdateData, { rejectWithValue }) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_ISSUE,
        variables: issueUpdateData,
        fetchPolicy: 'no-cache',
      });

      const result = data?.UpdateIssue;

      if (!result) {
        return rejectWithValue('Failed to update issue.');
      }

      return result;
    } catch (error) {
      console.error('Error updating issue:', error);
      return rejectWithValue(error?.message || 'Failed to update issue.');
    }
  }
);
const initialState = {
  issues: [],
};

const issuesSlice = createSlice({
    name: 'issues',
    initialState,
    reducers: {},
extraReducers: (builder)=>{
    builder
    .addCase(getAllIssuesThunk.fulfilled, (state, action) => {
      state.issues = action.payload;
    })
  }
});
 
export default issuesSlice.reducer;
